import { useEffect } from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

import FORMATS from '../utils/formats';

const MX_COUNTRY_CODE = '52';
const MX_PHONE_DIGITS = 10;

const normalizeMxPhoneDigits = (raw) => {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return '';

  let normalized = digits;
  if (normalized.startsWith(MX_COUNTRY_CODE) && normalized.length > MX_PHONE_DIGITS) {
    normalized = normalized.slice(MX_COUNTRY_CODE.length);
  }
  if (normalized.length > MX_PHONE_DIGITS) {
    normalized = normalized.slice(0, MX_PHONE_DIGITS);
  }
  return normalized;
};

function InputMxPhone(props) {
  const {
    inputRef,
    name,
    onChange,
    onBlur,
    value,
    ...other
  } = props;

  const normalizedValue = normalizeMxPhoneDigits(value);
  const rawDigits = String(value ?? '').replace(/\D/g, '');

  useEffect(() => {
    if (!onChange) return;
    if (rawDigits && rawDigits !== normalizedValue) {
      onChange({
        target: {
          name,
          value: normalizedValue,
        },
      });
    }
  }, [name, onChange, normalizedValue, rawDigits]);

  return (
    <NumberFormat
      {...other}
      format={FORMATS.MX_PHONE}
      getInputRef={inputRef}
      isNumericString
      type="tel"
      onBlur={onBlur}
      value={normalizedValue}
      onValueChange={({ value }) => {
        const nextValue = normalizeMxPhoneDigits(value);
        onChange({
          target: {
            name,
            value: nextValue,
          },
        });
      }}
    />
  );
}

InputMxPhone.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InputMxPhone;
